module.exports = __webpack_public_path__ + "static/media/ram.91fc0c14.svg";